// storageUtils.ts

/**
 * Sets a value in localStorage with an expiration time
 * @param storageKey - The key under which to store the value
 * @param storageValue - The value to be stored
 * @param expiresInMs - Expiration time in milliseconds
 */
export const setLocalStorageWithExpiry = (
  storageKey: string,
  storageValue: any,
  expiresInMs: number
) => {
  const currentTime = new Date().getTime();
  const storageObject = {
    data: storageValue,
    expiresAt: currentTime + expiresInMs,
  };
  localStorage.setItem(storageKey, JSON.stringify(storageObject));
};

/**
 * Retrieves a value from localStorage and checks if it's expired
 * @param storageKey - The key of the stored value
 * @returns The stored value if valid, otherwise null
 */
export const getLocalStorageWithExpiry = (storageKey: string) => {
  const storedValue = localStorage.getItem(storageKey);
  if (!storedValue) return null;

  const parsedValue = JSON.parse(storedValue);
  const currentTime = new Date().getTime();

  if (currentTime > parsedValue.expiresAt) {
    localStorage.removeItem(storageKey);
    return null;
  }

  return parsedValue.data;
};

/**
 * Removes an item from localStorage
 * @param storageKey - The key of the item to remove
 */
export const removeLocalStorageItem = (storageKey: string) => {
  localStorage.removeItem(storageKey);
};
/**
 * Retrieves a URL parameter by name
 * @param name - The name of the URL parameter
 * @returns The value of the URL parameter or null if not found
 */
export const getUrlParameter = (name: string): string | null => {
  if (typeof window === "undefined") return null;
  const url = new URL(window.location.href);
  return url.searchParams.get(name);
};
